export const SENSOR_CONFIGURATION_THRESHOLD = "2.7.0";

// Durata (ms) per cui la preview del sensore resta in stato di allarme dopo
// l'ultima rilevazione. Parametro di build: ALARM_DISPLAY_SECONDS (stringa).
// Default 120s (safety) se la variabile non è definita nel build (es. test).
const ALARM_DISPLAY_SECONDS = parseInt(process.env.ALARM_DISPLAY_SECONDS, 10) || 120;
export const ALARM_DISPLAY_MS = ALARM_DISPLAY_SECONDS * 1000;